import EventSideSection from '@/features/dashboard/components/EventSideSection'
import InsightList from '@/features/insight/components/InsightList'
import { MainLayout, Section, SplitLayout } from '@/shared/components'
import PageHeader from '@/shared/components/PageHeader'
import { Stack } from '@fluentui/react'
import DigestMedia from '@/features/dashboard/components/DigestMedia'
import useAccountName from '@/features/auth/hooks/useAccountName'
import RecentDocuments from '@/features/dashboard/components/RecentDocuments'
import { IInsightTag } from '@/features/insight/shared/types'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectIsCAEmployee } from '@/features/auth/redux/authSelectors'

const Dashboard = () => {
  const { accountName } = useAccountName()
  const history = useHistory()
  const isCAEmployee = useSelector(selectIsCAEmployee)

  const updateFeaturedInsightTags = (tag: IInsightTag) => {
    const selectedTag = tag && JSON.stringify([tag])
    history.push(`/insights?tag=${selectedTag}`)
  }

  const leftContent = (
    <>
      {!isCAEmployee ? (<RecentDocuments />) : null}
      <InsightList isDashboard setTags={updateFeaturedInsightTags}/>
    </>
  )

  const rightContent = (
    <Stack tokens={{ childrenGap: 24 }}>
      <Stack.Item>
        {/* <TeamCard /> */}
      </Stack.Item>
      <Stack.Item>
        <DigestMedia mediaId='main-investment-dashboard-media' />
      </Stack.Item>
      <Stack.Item>
        <EventSideSection />
      </Stack.Item>
    </Stack>
  )

  return (
    <MainLayout>
      <PageHeader label={accountName ? `${accountName}'s Dashboard` : 'Dashboard'} />
      <div className='c-dashboard__message-table'>
        {/* <MessagesTableSection /> */}
      </div>
      <Section>
        <SplitLayout
          renderHeader={false}
          leftContent={leftContent}
          rightContent={rightContent}
        />
      </Section>
    </MainLayout>
  )
}

export default Dashboard